import React from "react";
import { consentDoc, fmtDateTime } from "@/lib/consentTemplate";

const Rich = ({ text }) => (
  <>{text.split(/\*\*(.+?)\*\*/g).map((p, i) => (i % 2 ? <b key={i}>{p}</b> : p))}</>
);

const Fields = ({ rows }) => (
  <dl className="my-3 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1.5 text-sm">
    {rows.map(([k, x]) => (
      <div key={k} className="flex flex-col border-b border-slate-100 py-1">
        <dt className="text-[11px] uppercase tracking-wider text-slate-500">{k}</dt>
        <dd className={x.startsWith("[") ? "text-amber-700 italic" : "text-navy font-medium"}>{x}</dd>
      </div>
    ))}
  </dl>
);

const SigBox = ({ title, img, lines, testId }) => (
  <div className="rounded-lg border border-slate-200 p-3" data-testid={testId}>
    <div className="text-[11px] uppercase tracking-wider text-slate-500">{title}</div>
    {img ? <img src={img} alt={title} className="my-1 h-20 object-contain" /> : <div className="my-1 flex h-20 items-center text-xs italic text-slate-400">Not yet signed</div>}
    {lines.filter(Boolean).map((l) => <div key={l} className="text-xs text-slate-600">{l}</div>)}
  </div>
);

export const SignatureBlock = ({ consent: c }) => {
  if (!c?.signature_image && !c?.countersign_image) return null;
  const loc = c.signed_location || {};
  const where = loc.address || (loc.lat != null ? `${loc.lat.toFixed(5)}, ${loc.lng.toFixed(5)}` : `not shared (${loc.status || "unavailable"})`);
  return (
    <section className="mt-6 grid gap-3 sm:grid-cols-2" data-testid="consent-signature-block">
      <SigBox title="Employee e-signature" img={c.signature_image} testId="consent-employee-signature" lines={[
        c.signature_name, c.signed_at && `Signed ${fmtDateTime(c.signed_at)}`,
        c.otp_verified && `Verified by email code (${c.signed_email})`,
        c.signed_device && `Device: ${c.signed_device}`, c.signed_ip && `IP: ${c.signed_ip}`, `Location: ${where}`]} />
      <SigBox title="Founder counter-signature" img={c.countersign_image} testId="consent-founder-signature" lines={[
        c.countersigned_by, c.countersigned_at && `Signed ${fmtDateTime(c.countersigned_at)}`, "For VNS Vinayaka Group of Enterprises"]} />
    </section>
  );
};

export const ConsentDocument = ({ consent }) => {
  const d = consentDoc(consent);
  return (
    <article className="font-serif text-[14px] leading-relaxed text-slate-800" data-testid="consent-document">
      <div className="text-center text-xs font-bold tracking-[0.25em] text-gold-dark">VNS VINAYAKA GROUP OF ENTERPRISES</div>
      <h2 className="mt-2 border-b-2 border-gold pb-3 text-center font-heading text-base sm:text-lg font-bold text-navy">
        EMPLOYEE CONSENT AND ACKNOWLEDGEMENT FOR TEAM REALLOCATION AND CAPPED PART-TIME WORKING ARRANGEMENTS
      </h2>
      <Fields rows={d.header} />
      {d.sections.map((s) => (
        <section key={s.title} className="mt-5">
          <h3 className="font-heading text-sm font-bold text-navy">{s.title}</h3>
          {s.body.map((p) => <p key={p} className="mt-2"><Rich text={p} /></p>)}
          {s.fields && <Fields rows={s.fields} />}
          {s.list && <ol className="mt-2 list-decimal space-y-1 pl-6">{s.list.map((p) => <li key={p}>{p}</li>)}</ol>}
          {(s.after || []).map((p) => <p key={p} className="mt-2">{p}</p>)}
        </section>
      ))}
      <SignatureBlock consent={consent} />
    </article>
  );
};
